// extracted by mini-css-extract-plugin
export default {"classes":"ServiceTerms_classes__+lTzw","btnDiv":"ServiceTerms_btnDiv__CrAmk","bgGreen":"ServiceTerms_bgGreen__y1Qkp","bgRed":"ServiceTerms_bgRed__ycMqR"};